import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import AddressForm from "./AddressForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../../sc-utilities";
import * as actions from './store/addressActions';
import History from "../../../../History";
import { hasPermission } from "../../../sc-utilities";
import { CancelToken } from 'axios';
import { states, getStatesList, getCountryList } from '../../../sc-utilities/CountriesAndUSstatesList';
import countries from 'i18n-iso-countries';

const AddressEdit = props => {
    const { activeCustomerID, loadAddress, translations, userLanguage, address, loadAddressInit, updateAddress, permissions } = props;
    const [editData, setEditData] = useState({ loadingData: true });

    try {
        let lang = userLanguage;
        if (userLanguage.includes("zh-")) {
            lang = "zh";
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`));
    } catch (error) {
        console.log(error)
    }

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await loadAddress({ ActiveCustomerID: activeCustomerID, AddressID: parseURL(window.location.href).addressID }, { cancelToken: requestToken.token })
            setEditData({ loadingData: false })
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            loadAddressInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["Type"] = address && address.Type ? address.Type : '';
        data['Country'] = data ? data?.Country?.key : '';

        data['State'] = data?.Country !== "US" ? null : data?.State?.value;
        let result = await updateAddress({ ...data, ActiveCustomerID: activeCustomerID, AddressID: parseURL(window.location.href).addressID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };
    let countryName = (getCountryList(countries, userLanguage) ?? []).filter(el => el.key === address?.Country);
    let stateName = (getStatesList(states) ?? []).filter(el => el.value === address?.State);

    let initialValues = {
        City: address && address.City ? address.City : '',
        Country: countryName[0] || "",
        State: stateName[0] || "",
        AddressLine1: address && address.AddressLine1 ? address.AddressLine1 : '',
        AddressLine2: address && address.AddressLine2 ? address.AddressLine2 : '',
        GLN: address && address.GLN ? address.GLN : ''
    }

    let formSettings = {
        Validation: {
            City: Yup.string().required(),
            Country: Yup.string().required(),
            State: Yup.string().notRequired(),
            AddressLine1: Yup.string().required(),
            AddressLine2: Yup.string().required(),
            GLN: Yup.string().required()
        },
        FormTitle: translations["edit_address"] || "Edit address",
        ButtonSubmit: hasPermission(permissions, 'address_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loadingData ?
            <AddressForm
                countryList={getCountryList(countries, userLanguage)}
                usStatesList={getStatesList(states)}
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                permissions={editData.permissions}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        address: state.client.address.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateAddress: data => dispatch(actions.editAddress(data)),
        loadAddress: (data, options) => dispatch(actions.loadAddress(data, options)),
        loadAddressInit: () => dispatch(actions.loadAddressInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressEdit);
